import React, { memo } from "react";

const SensorNode = memo(({ data }) => {
  const { label, sensorDetail } = data;
  const { isDetected, isRecording } = sensorDetail;

  // console.log("DATA", data);
  // console.log("SENSOR DETAIL", sensorDetail);

  const checkSensor = () => {
    let bg = "gray";
    if (isDetected) {
      if (isRecording) {
        bg = "#5bc673";
      } else {
        bg = "#d9534f";
      }
    } else {
      bg = "#fd9d0d";
    }
    return bg;
  };

  return (
    <div
      style={{
        minWidth: "25px",
        // height: "100%",
        // backgroundColor: "red",
        backgroundColor: checkSensor(),
        color: "white",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0.2em",
      }}
    >
      <p
        style={{
          fontWeight: "bold",
          fontSize: "0.8rem",
          margin: "0",
          padding: "0",
        }}
      >
        {label}
      </p>
    </div>
  );
});

const LayoutNode = memo(({ data }) => {
  const { url } = data;
  return (
    <img
      alt={`Sensors Layout`}
      className="nodrag"
      style={{ width: "100%" }}
      src={url}
      // src="http://jembatankhusussumsel.com:5002/api/Layout/image/9422b836-081e-4246-aed6-e59bfaf0cf6f.jpeg"
      draggable="false"
    />
  );
});

export { SensorNode, LayoutNode };
